import React from 'react';
import { connect } from 'react-redux';
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
  Spinner,
} from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes, faMinusCircle } from '@fortawesome/pro-light-svg-icons';
import { saveUpdatedTranslations } from '../../../actions/translations';

class DeleteModal extends React.PureComponent {
  handleDelete = (languageSelected, translations, site) => {
    const filtered = Object.keys(translations)
      .filter((language) => language !== languageSelected)
      .reduce((obj, key) => ({
        ...obj,
        [key]: translations[key],
      }), {});
    if (Object.keys(filtered).length === 0) {
      // TODO: Please use a proper UI library for alerts like this.
      // alert('Cannot remove the only language.');
    } else {
      saveUpdatedTranslations(filtered, site, true).then(() => this.close());
    }
  };

  close = () => {
    const { dispatch } = this.props;
    dispatch({ type: 'SET_DELETE_TRANSLATION_MODAL', payload: false });
  };

  render() {
    const {
      isOpen,
      languageSelected,
      translations,
      site,
      deleting,
    } = this.props;
    return (
      <Modal isOpen={isOpen} toggle={this.close} zIndex="100000">
        <ModalHeader toggle={this.close}>
          <b>Warning!</b>
        </ModalHeader>
        <ModalBody>
          Are you sure you want to delete&nbsp;
          {languageSelected}
          ? You cannot undo this action.
        </ModalBody>
        <ModalFooter>
          <Button
            color="danger"
            onClick={() => this.handleDelete(languageSelected, translations, site)}
            disabled={deleting}
          >
            <FontAwesomeIcon icon={faMinusCircle} size="lg" className="me-2" />
            Delete
            {deleting && <Spinner size="sm" className="ms-2" />}
          </Button>
          <Button color="secondary" onClick={this.close}>
            <FontAwesomeIcon icon={faTimes} size="lg" className="me-2" />
            Cancel
          </Button>
        </ModalFooter>
      </Modal>
    );
  }
}

const mapStateToProps = (store) => ({
  isOpen: store.modals.deleteTranslationOpen,
  languageSelected: store.translations.tab,
  translations: store.translations.sets,
  deleting: store.translations.deleting,
});

export default connect(mapStateToProps)(DeleteModal);
